import { useQuery } from '@tanstack/react-query'
import { billingApi, type CatalogProduct, type ProductSKU } from '../api/client'

// The catalog is the single price source for the whole frontend. Every screen
// that shows a price (landing, pricing, products, product detail, cart,
// billing, mail) reads it through this hook, so no two screens can quote
// different numbers, and the server re-prices every checkout from the same
// table it serves here.
//
// One shared query key means one request per session no matter which screen
// mounts first.
export function useCatalog() {
  return useQuery({
    queryKey: ['catalog'],
    queryFn: billingApi.getCatalog,
    staleTime: 10 * 60 * 1000,
  })
}

// One product's catalog entry, or undefined until the catalog has loaded.
// Callers render a placeholder for undefined rather than inventing a price:
// a hardcoded fallback is how the landing page ended up quoting a stale one.
export function useProduct(sku: ProductSKU): CatalogProduct | undefined {
  const { data } = useCatalog()
  return data?.products.find((p) => p.sku === sku)
}
